// import React, { useState, useEffect } from 'react';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import Announce from '../announce/Announce';

// export default function SessionForm() {
//   const [mode, setMode] = useState('Online');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [state, setState] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   const HandleSubmit = async(e) => {
//     e.preventDefault();
//     try {
//       alert('Form Submitted Successfully');
//       console.log({ mode, name, phone, email, state });
//       const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/enquiry`,{
//         method:'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body : JSON.stringify({mode,name,phone,email,state})
//       })

//       const data = await res.json()
//       console.log(data)
//       setName('');
//       setPhone('');
//       setEmail('');
//       setState('');
//     } catch (err) {
//       console.log('Error : ', err);
//     }
//   };

//   const handleSendOtp = () => {
//     if (phone.length >= 10) {
//       setIsOtpSent(true);
//       console.log('OTP sent to:', phone);
//     }
//   };

//   return (
//     <div
//       className="min-vh-100 d-flex align-items-start justify-content-end w-100"
//       style={{
//         backgroundImage: "url(/MainHome/Homebanner1.png)",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         paddingTop: "120px",
//         paddingRight: "10px",
//       }}
//     >
//       {/* <h1
//         style={{
//           position: 'absolute',
//           top: isMobile ? '120px' : '100px',
//           left: 0,
//           width: '100%',
//           textAlign:  'center',
//           fontWeight: 'bold',
//           fontSize: isMobile ? '1.5rem' : '4rem',  // Reduced size for mobile
//           lineHeight: '1.2',
//           zIndex: 2,
//           color: '#222',
//           padding: isMobile ? '0 15px' : '0',         // Padding for mobile
//         }}
//       >
//         Welcome to <span style={{ color: '#A259E0' }}>Transparent Education</span>
//         <br />
//         Choices, Open to the World.
//       </h1> */}
// {/* 
//        <div>
//           <Announce/>
//         </div>
//        */}
//       <div
//         className="card shadow-lg p-5"
//         style={{
//           maxWidth: "500px",
//           width: "100%",
//           background: "#F3ECF8",
//           borderRadius: "28px",
//           border: "none",
//           marginRight: isMobile ? '0' : '60px',
//           marginTop : '30px',

//         }}
//       >
// {/* 
//          <div>
//           <Announce/>
//         </div>
//         */}

//         <div className="text-center mb-2">
//           <div
//             className="mx-auto mb-2"
//             style={{
//               background: "linear-gradient(100deg, #4a90e2, #9b59b6)",
//               borderRadius: "14px",
//               width: 56,
//               height: 56,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <i className="bi bi-calendar-check text-white fs-2"></i>
//           </div>
//           <h3
//   className="fw-bold mb-1"
//   style={{
//     fontSize: "2rem",
//     letterSpacing: ".5px",
//     background: "#A259E0",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     backgroundClip: "text",
//     color: "#A259E0",
//   }}
// >
//   Start Your Free Session Today
// </h3>

//           <div className="text-muted" style={{ fontSize: "1.25rem" }}>
//             Guidance from top trainers & professionals
//           </div>
//         </div>
//         <div className="mb-2 text-center">
//           <span className="fw-semibold" style={{ color: "#A259E0" }}>Select how you want to learn</span>
//         </div>
//         <div className="d-flex justify-content-between gap-3 mb-4">
//           <button
//             type="button"
//             className={`btn w-50 fw-semibold py-2 ${mode === "Online" ? "btn-primary" : "btn-outline-secondary"}`}
//             style={{
//               borderRadius: "12px",
//               background: mode === "Online" ? "linear-gradient(100deg, #4a90e2, #9b59b6)" : "#fff",
//               color: mode === "Online" ? "#fff" : "#6f42c1",
//               borderWidth: mode === "Online" ? "2px" : "1px",
//               borderColor: "white",
//             }}
//             onClick={() => setMode("Online")}
//           >
//             Online
//             <div className="small" style={{ color: mode === "Online" ? "#e5e5e5" : "#6c757d" }}>From anywhere</div>
//           </button>
//           <button
//             type="button"
//             className={`btn w-50 fw-semibold py-2 ${mode === "Offline" ? "btn-primary" : "btn-outline-secondary"}`}
//             style={{
//               borderRadius: "12px",
//               background: mode === "Offline" ? "linear-gradient(100deg, #4a90e2, #9b59b6)" : "#fff",
//               color: mode === "Offline" ? "#fff" : "#6f42c1",
//               borderWidth: mode === "Offline" ? "2px" : "1px",
//               borderColor: "white",
//             }}
//             onClick={() => setMode("Offline")}
//           >
//             Offline
//             <div className="small" style={{ color: mode === "Offline" ? "#e5e5e5" : "#6c757d" }}>In person</div>
//           </button>
//         </div>
//         <div className="mb-3 text-center fw-bold fs-5" style={{ color: "#6f42c1" }}>
//           Enter Your Details
//         </div>
//         <form onSubmit={HandleSubmit}>
//   <div className="col-12" style={{marginBottom : '10px'}}>
//     <div className="rbt-form-group">
//       {/* <label style={{fontSize:'15px'}} htmlFor="name">Full Name *</label> */}
//       <input
//         id="name"
//         type="text"
//         name="name"
//         value={name}
//         onChange={(e) => setName(e.target.value)}
//         placeholder="Enter your full name"
//         required
//       />
//     </div>
//   </div>

//   <div className="col-12" style={{marginBottom : '10px'}}>
//     <div className="rbt-form-group">
//       {/* <label style={{fontSize:'15px'}} htmlFor="phone">Mobile Number *</label> */}
//       <input
//         id="phone"
//         type="tel"
//         name="phone"
//         value={phone}
//         onChange={(e) => setPhone(e.target.value)}
//         placeholder="Enter your mobile number"
//         required
//       />
//     </div>
//   </div>

//   <div className="col-12" style={{marginBottom : '10px'}}>
//     <div className="rbt-form-group">
//       {/* <label style={{fontSize:'15px'}} htmlFor="email">Email Address *</label> */}
//       <input
//         id="email"
//         type="email"
//         name="email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         placeholder="Enter email address"
//         required
//       />
//     </div>
//   </div>

//   <div className="col-12">
//     <div className="rbt-form-group">
//       {/* <label style={{fontSize:'15px'}} htmlFor="state">State *</label> */}
//       <input
//         id="state"
//         type="text"
//         name="state"
//         value={state}
//         onChange={(e) => setState(e.target.value)}
//         placeholder="Enter your state"
//         required
//       />
//     </div>
//   </div>

//   <button
//     type="submit"
//     className="btn w-100 py-3 fw-bold"
//     style={{
//       background: "linear-gradient(100deg, #4a90e2, #9b59b6)",
//       border: "none",
//       borderRadius: "12px",
//       fontSize: "1.7rem",
//       color: 'white',
//       marginTop:'10px'
//     }}
//   >
//     Schedule
//   </button>
// </form>
//         <div className="text-center mt-3">
//           <p className="text-muted small mb-0">
//             By continuing, you agree to our Terms & Conditions
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }




// import React, { useState, useEffect } from 'react';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import Announce from '../announce/Announce';

// export default function SessionForm() {
//   const [mode, setMode] = useState('Online');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [state, setState] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   const HandleSubmit = async(e) => {
//     e.preventDefault();
//     try {
//       alert('Form Submitted Successfully');
//       console.log({ mode, name, phone, email, state });
//       const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/enquiry`,{
//         method:'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body : JSON.stringify({mode,name,phone,email,state})
//       })

//       const data = await res.json()
//       console.log(data)
//       setName('');
//       setPhone('');
//       setEmail('');
//       setState('');
//     } catch (err) {
//       console.log('Error : ', err);
//     }
//   };

//   const handleSendOtp = () => {
//     if (phone.length >= 10) {
//       setIsOtpSent(true);
//       console.log('OTP sent to:', phone);
//     }
//   };

//   return (
//   <>
//     <div
//       className="min-vh-100 d-flex align-items-start justify-content-end w-100"
//       style={{
//         backgroundImage: "url(/MainHome/Homebanner1.png)",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         paddingTop: "120px",
//         paddingRight: "10px",
//       }}
//     >
//       <div
//         className="card shadow-lg p-5"
//         style={{
//           maxWidth: "500px",
//           width: "100%",
//           background: "#F3ECF8",
//           borderRadius: "28px",
//           border: "none",
//           marginRight: isMobile ? "0" : "60px",
//           marginTop: "30px",
//         }}
//       >
//         <div className="text-center mb-2">
//           <div
//             className="mx-auto mb-2"
//             style={{
//               background: "linear-gradient(100deg, #4a90e2, #9b59b6)",
//               borderRadius: "14px",
//               width: 56,
//               height: 56,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <i className="bi bi-calendar-check text-white fs-2"></i>
//           </div>
//           <h3
//             className="fw-bold mb-1"
//             style={{
//               fontSize: "2rem",
//               letterSpacing: ".5px",
//               background: "#A259E0",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               backgroundClip: "text",
//               color: "#A259E0",
//             }}
//           >
//             Start Your Free Session Today
//           </h3>

//           <div className="text-muted" style={{ fontSize: "1.25rem" }}>
//             Guidance from top trainers & professionals
//           </div>
//         </div>
//         <div className="mb-3 text-center fw-bold fs-5" style={{ color: "#6f42c1" }}>
//           Enter Your Details
//         </div>
//         <form onSubmit={HandleSubmit}>
//           <div className="col-12" style={{ marginBottom: "10px" }}>
//             <div className="rbt-form-group">
//               <input
//                 id="name"
//                 type="text"
//                 name="name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 placeholder="Enter your full name"
//                 required
//               />
//             </div>
//           </div>

//           <div className="col-12" style={{ marginBottom: "10px" }}>
//             <div className="rbt-form-group">
//               <input
//                 id="phone"
//                 type="tel"
//                 name="phone"
//                 value={phone}
//                 onChange={(e) => setPhone(e.target.value)}
//                 placeholder="Enter your mobile number"
//                 required
//               />
//             </div>
//           </div>

//           <div className="col-12" style={{ marginBottom: "10px" }}>
//             <div className="rbt-form-group">
//               <input
//                 id="email"
//                 type="email"
//                 name="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter email address"
//                 required
//               />
//             </div>
//           </div>

//           <div className="col-12" style={{ marginBottom: "10px" }}>
//             <div className="rbt-form-group">
//               <input
//                 id="state"
//                 type="text"
//                 name="state"
//                 value={state}
//                 onChange={(e) => setState(e.target.value)}
//                 placeholder="Enter your state"
//                 required
//               />
//             </div>
//           </div>

//           {/* Radio buttons for Online / Offline */}
//           {/* <div className="col-12 mb-3">
//             <span className="fw-semibold" style={{ color: "#A259E0" }}>
//               Select how you want to learn
//             </span>
//             <div className="d-flex justify-content-between gap-3 mt-2">
//               <label
//                 htmlFor="modeOnline"
//                 className={`btn w-50 fw-semibold py-2 ${
//                   mode === "Online" ? "btn-primary" : "btn-outline-secondary"
//                 }`}
//                 style={{
//                   borderRadius: "12px",
//                   background:
//                     mode === "Online"
//                       ? "linear-gradient(100deg, #4a90e2, #9b59b6)"
//                       : "#fff",
//                   color: mode === "Online" ? "#fff" : "#6f42c1",
//                   borderWidth: mode === "Online" ? "2px" : "1px",
//                   borderColor: "white",
//                   cursor: "pointer",
//                 }}
//               >
//                 <input
//                   id="modeOnline"
//                   type="radio"
//                   name="mode"
//                   value="Online"
//                   checked={mode === "Online"}
//                   onChange={() => setMode("Online")}
//                   style={{ display: "none" }}
//                 />
//                 Online
//                 <div
//                   className="small"
//                   style={{ color: mode === "Online" ? "#e5e5e5" : "#6c757d" }}
//                 >
//                   From anywhere
//                 </div>
//               </label>

//               <label
//                 htmlFor="modeOffline"
//                 className={`btn w-50 fw-semibold py-2 ${
//                   mode === "Offline" ? "btn-primary" : "btn-outline-secondary"
//                 }`}
//                 style={{
//                   borderRadius: "12px",
//                   background:
//                     mode === "Offline"
//                       ? "linear-gradient(100deg, #4a90e2, #9b59b6)"
//                       : "#fff",
//                   color: mode === "Offline" ? "#fff" : "#6f42c1",
//                   borderWidth: mode === "Offline" ? "2px" : "1px",
//                   borderColor: "white",
//                   cursor: "pointer",
//                 }}
//               >
//                 <input
//                   id="modeOffline"
//                   type="radio"
//                   name="mode"
//                   value="Offline"
//                   checked={mode === "Offline"}
//                   onChange={() => setMode("Offline")}
//                   style={{ display: "none" }}
//                 />
//                 Offline
//                 <div
//                   className="small"
//                   style={{ color: mode === "Offline" ? "#e5e5e5" : "#6c757d" }}
//                 >
//                   In person
//                 </div>
//               </label>
//             </div>
//           </div> */}



//           <div className="col-12 mb-3">
//             <div className="d-flex gap-2 mt-2">
//               <span className="fw-semibold" style={{  fontSize : '1.5rem' , marginTop : '2px' }}>
//                 Select Mode
//               </span>
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="radio"
//         id="modeOnline"
//         name="mode"
//         value="Online"
//         checked={mode === "Online"}
//         onChange={() => setMode("Online")}
//       />
//       <label className="form-check-label" htmlFor="modeOnline">
//         Online 
//         {/* <span className="text-muted small">From anywhere</span> */}
//       </label>
//     </div>

//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="radio"
//         id="modeOffline"
//         name="mode"
//         value="Offline"
//         checked={mode === "Offline"}
//         onChange={() => setMode("Offline")}
//       />
//       <label className="form-check-label" htmlFor="modeOffline">
//         Offline 
//       </label>
//     </div>
//   </div>
// </div>


//           <button
//             type="submit"
//             className="btn w-100 py-3 fw-bold"
//             style={{
//               background: "linear-gradient(100deg, #4a90e2, #9b59b6)",
//               border: "none",
//               borderRadius: "12px",
//               fontSize: "1.7rem",
//               color: "white",
//               marginTop: "10px",
//             }}
//           >
//             Schedule
//           </button>
//         </form>
//         <div className="text-center mt-3">
//           <p className="text-muted small mb-0" style={{fontSize : '1.10rem'}}>
//             By continuing, you agree to our Terms & Conditions
//           </p>
//         </div>
//       </div>
//     </div>
//   </>
// );

// }




// import React, { useState, useEffect } from 'react';
// // import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// // import Announce from '../announce/Announce';
// import { useAppContext } from '@/context/Context';

// export default function SessionForm() {
//   const [mode, setMode] = useState('Online');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [state, setState] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const { isLightTheme } = useAppContext();

//   useEffect(() => {
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   const HandleSubmit = async(e) => {
//     e.preventDefault();
//     try {
//       alert('Form Submitted Successfully,Our Team Will Contact You Soon.');
//       console.log({ mode, name, phone, email, state });
//       const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/enquiry`,{
//         method:'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body : JSON.stringify({mode,name,phone,email,state})
//       })

//         const sessionres = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/session-mail`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body : JSON.stringify({mode,name,phone,email,state})
//     });

//       const data = await res.json()
//       console.log(data)
//       setName('');
//       setPhone('');
//       setEmail('');
//       setState('');
//     } catch (err) {
//       console.log('Error : ', err);
//     }
//   };

//   const handleSendOtp = () => {
//     if (phone.length >= 10) {
//       setIsOtpSent(true);
//       console.log('OTP sent to:', phone);
//     }
//   };

//   return (
//     <>
//       <style jsx>{`
//         .hero-section {
//           min-height: 100vh;

//           background-size: cover;
//           background-position: center;
//           background-repeat: no-repeat;
//           padding-top: 120px;
//           padding-right: 10px;
//         }

//         .form-card {
//           background: #F3ECF8;
//           border-radius: 28px;
//           border: none;
//           box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
//           margin-top: 30px;
//         }

//         .icon-container {
//           background: linear-gradient(100deg, #4a90e2, #9b59b6);
//           border-radius: 14px;
//           width: 56px;
//           height: 56px;
//         }

//         .gradient-text {
//           background: #A259E0;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//           color: #A259E0;
//           font-size: 2rem;
//           letter-spacing: 0.5px;
//         }

//         .rbt-form-group input {
//           width: 100%;
//           padding: 12px 16px;
//           border: 2px solid #e9ecef;
//           border-radius: 8px;
//           font-size: 1.5rem;
//           transition: all 0.3s ease;
//           background-color: #fff;
//         }

//         .rbt-form-group input:focus {
//           outline: none;
//           border-color: #A259E0;
//           box-shadow: 0 0 0 0.2rem rgba(162, 89, 224, 0.25);
//         }

//         .rbt-form-group input::placeholder {
//           color: #6c757d;
//           font-size: 1.5rem;
//         }

//         .submit-btn {
//           background: linear-gradient(100deg, #4a90e2, #9b59b6);
//           border: none;
//           border-radius: 12px;
//           color: white;
//           font-size: 1.7rem;
//           padding: 12px 0;
//           margin-top: 10px;
//           transition: all 0.3s ease;
//         }

//         .submit-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
//         }

//         /* Mobile Styles (≤576px) */
//         @media (max-width: 576px) {
//           .hero-section {
//             padding-top: 60px;
//             padding-right: 5px;
//             padding-left: 5px;
//             align-items: center !important;
//             justify-content: center !important;
//           }

//           .form-card {
//             max-width: 95vw !important;
//             margin: 20px auto !important;
//             padding: 2rem !important;
//           }

//           .gradient-text {
//             font-size: 1.5rem !important;
//           }

//           .description-text {
//             font-size: 1rem !important;
//           }

//           .submit-btn {
//             font-size: 1.4rem !important;
//             padding: 10px 0 !important;
//           }

//           .mode-label {
//             font-size: 1.2rem !important;
//           }

//           .terms-text {
//             font-size: 0.9rem !important;
//           }
//         }

//         /* Small Mobile Styles (≤480px) */
//         @media (max-width: 480px) {
//           .form-card {
//             padding: 1.5rem !important;
//             border-radius: 20px !important;
//           }

//           .gradient-text {
//             font-size: 1.3rem !important;
//           }

//           .description-text {
//             font-size: 0.9rem !important;
//           }

//           .icon-container {
//             width: 48px !important;
//             height: 48px !important;
//           }

//           .submit-btn {
//             font-size: 1.2rem !important;
//           }
//         }

//         /* Tablet Portrait Styles (577px - 768px) */
//         @media (min-width: 577px) and (max-width: 768px) {
//           .hero-section {
//             padding-top: 80px;
//             justify-content: center !important;
//           }

//           .form-card {
//             max-width: 90vw !important;
//             margin: 30px auto !important;
//             padding: 2.5rem !important;
//           }

//           .gradient-text {
//             font-size: 1.8rem !important;
//           }

//           .submit-btn {
//             font-size: 1.5rem !important;
//           }
//         }

//         /* Tablet Landscape Styles (769px - 992px) */
//         @media (min-width: 769px) and (max-width: 992px) {
//           .hero-section {
//             padding-top: 100px;
//             justify-content: flex-end !important;
//             padding-right: 30px !important;
//           }

//           .form-card {
//             max-width: 450px !important;
//             margin-right: 40px !important;
//           }
//         }

//         /* Small Desktop Styles (993px - 1200px) */
//         @media (min-width: 993px) and (max-width: 1200px) {
//           .hero-section {
//             justify-content: flex-end !important;
//             padding-right: 40px !important;
//           }

//           .form-card {
//             margin-right: 50px !important;
//           }
//         }

//         /* Large Desktop Styles (≥1201px) */
//         @media (min-width: 1201px) {
//           .hero-section {
//             justify-content: flex-end !important;
//             padding-right: 10px !important;
//           }

//           .form-card {
//             margin-right: 60px !important;
//           }
//         }

//         /* Ultra-wide Screens (≥1400px) */
//         @media (min-width: 1400px) {
//           .form-card {
//             margin-right: 80px !important;
//           }
//         }
//       `}</style>

//       <div className="d-flex align-items-start justify-content-end w-100 hero-section" style={{    backgroundImage: `url(${
//       isLightTheme
//         ? "/MainHome/Homebanner1.png"
//         : "/MainHome/Homebanner5.png"
//     })`}}>
//         <div className="card shadow-lg p-5 form-card" style={{ maxWidth: "500px", width: "100%" }}>
//           {/* Header Section */}
//           <div className="text-center mb-2">
//             <div className="mx-auto mb-2 d-flex align-items-center justify-content-center icon-container">
//               <i className="bi bi-calendar-check text-white fs-2"></i>
//             </div>

//             <h3 className="fw-bold mb-1 gradient-text">
//               Start Your Free Session Today
//             </h3>

//             <div className="text-muted description-text" style={{ fontSize: "1.25rem" }}>
//               Guidance from top trainers & professionals
//             </div>
//           </div>

//           {/* Form Title */}
//           <div className="mb-3 text-center fw-bold fs-5" style={{ color: "#6f42c1" }}>
//             Enter Your Details
//           </div>

//           {/* Form */}
//           <form onSubmit={HandleSubmit}>
//             {/* Name Field */}
//             <div className="col-12 mb-3">
//               <div className="rbt-form-group">
//                 <input
//                   id="name"
//                   type="text"
//                   name="name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   placeholder="Enter your full name"
//                   className="form-control"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Phone Field */}
//             <div className="col-12 mb-3">
//               <div className="rbt-form-group">
//                 <input
//                   id="phone"
//                   type="tel"
//                   name="phone"
//                   value={phone}
//                   onChange={(e) => setPhone(e.target.value)}
//                   placeholder="Enter your mobile number"
//                   className="form-control"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Email Field */}
//             <div className="col-12 mb-3">
//               <div className="rbt-form-group">
//                 <input
//                   id="email"
//                   type="email"
//                   name="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="Enter email address"
//                   className="form-control"
//                   required
//                 />
//               </div>
//             </div>

//             {/* State Field */}
//             <div className="col-12 mb-3">
//               <div className="rbt-form-group">
//                 <input
//                   id="state"
//                   type="text"
//                   name="state"
//                   value={state}
//                   onChange={(e) => setState(e.target.value)}
//                   placeholder="Enter your state"
//                   className="form-control"
//                   required
//                 />
//               </div>
//             </div>

//             {/* Mode Selection */}
//             <div className="col-12 mb-3">
//   <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 mt-2">
//     <span
//       className="fw-semibold mode-label"
//       style={{ fontSize: "1.5rem", marginTop: "2px" }}
//     >
//       Select Mode
//     </span>

//     <div className="d-flex gap-3">
//       <div className="form-check">
//         <input
//           className="form-check-input"
//           type="radio"
//           id="modeOnline"
//           name="mode"
//           value="Online"
//           checked={mode === "Online"}
//           onChange={() => setMode("Online")}
//         />
//         <label
//           className="form-check-label fw-semibold"
//           htmlFor="modeOnline"
//         >
//           Online
//         </label>
//       </div>

//       <div className="form-check">
//         <input
//           className="form-check-input"
//           type="radio"
//           id="modeOffline"
//           name="mode"
//           value="Offline"
//           checked={mode === "Offline"}
//           onChange={() => setMode("Offline")}
//         />
//         <label
//           className="form-check-label fw-semibold"
//           htmlFor="modeOffline"
//         >
//           Offline
//         </label>
//       </div>
//     </div>
//   </div>
// </div>


//             {/* Submit Button */}
//             <button
//               type="submit"
//               className="btn w-100 py-3 fw-bold submit-btn"
//             >
//               Schedule
//             </button>
//           </form>

//           {/* Terms */}
//           <div className="text-center mt-3">
//             <p className="text-muted small mb-0 terms-text" style={{ fontSize: '1.10rem' }}>
//               By continuing, you agree to our Terms & Conditions
//             </p>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useEffect } from 'react';
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
// import Announce from '../announce/Announce';
import { useAppContext } from '@/context/Context';
import { toast } from 'react-toastify';

export default function SessionForm() {
  const [mode, setMode] = useState('Online');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [state, setState] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const { isLightTheme } = useAppContext(); 

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const HandleSubmit = async (e) => {
    e.preventDefault();
    try {
      toast.success('Form Submitted Successfully,Our Team Will Contact You Soon.');
      console.log({ mode, name, phone, email, state });
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/enquiry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials : "include",
        body: JSON.stringify({ mode, name, phone, email, state })
      })

      const sessionres = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/session-mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode, name, phone, email, state })
      });

      const data = await res.json()
      console.log(data)
      setName('');
      setPhone('');
      setEmail('');
      setState('');
    } catch (err) {
      console.log('Error : ', err);
    }
  };

  const handleSendOtp = () => {
    if (phone.length >= 10) {
      setIsOtpSent(true);
      console.log('OTP sent to:', phone);
    }
  };

  return (
    <>
      <style jsx>{`
        .hero-section {
          min-height: 100vh;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          padding-top: 120px;
          padding-right: 10px;
        }

        .form-card {
          border-radius: 28px;
          border: none;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          margin-top: 30px;
          transition: background-color 0.3s ease, color 0.3s ease; /* Smooth transition */
        }

        /* Light Theme for form-card */
        .form-card.light-theme {
          background: #F3ECF8; /* Light purple background */
          color: #212529; /* Dark text for light theme */
        }

        /* Dark Theme for form-card */
        .form-card.dark-theme {
          background: #2a2a3e; /* Darker background */
          color: #e0e0e0; /* Light text for dark theme */
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.4); /* Stronger shadow for contrast */
        }


        .icon-container {
          background: linear-gradient(100deg, #4a90e2, #9b59b6);
          border-radius: 14px;
          width: 56px;
          height: 56px;
        }

        .gradient-text {
          background: #A259E0;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: #A259E0; /* Fallback for browsers not supporting -webkit-text-fill-color */
          font-size: 2rem;
          letter-spacing: 0.5px;
        }

        .rbt-form-group input {
          width: 100%;
          padding: 12px 16px;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          font-size: 1.5rem;
          transition: all 0.3s ease;
        }

        /* Light Theme for input */
        .rbt-form-group input.light-theme {
          background-color: #fff;
          color: #212529;
          border-color: #e9ecef;
        }
        .rbt-form-group input.light-theme:focus {
          border-color: #A259E0;
          box-shadow: 0 0 0 0.2rem rgba(162, 89, 224, 0.25);
        }
        .rbt-form-group input.light-theme::placeholder {
          color: #6c757d;
        }

        /* Dark Theme for input */
        .rbt-form-group input.dark-theme {
          background-color: #3b3b55; /* Darker input background */
          color: #e0e0e0; /* Light text */
          border-color: #555577; /* Softer border */
        }
        .rbt-form-group input.dark-theme:focus {
          outline: none;
          border-color: #A259E0; /* Still use the accent color for focus */
          box-shadow: 0 0 0 0.2rem rgba(162, 89, 224, 0.4);
        }
        .rbt-form-group input.dark-theme::placeholder {
          color: #aaaaaa; /* Lighter placeholder text */
        }

        .submit-btn {
          background: linear-gradient(100deg, #4a90e2, #9b59b6);
          border: none;
          border-radius: 12px;
          color: white;
          font-size: 1.7rem;
          padding: 12px 0;
          margin-top: 10px;
          transition: all 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        /* Specific text color for dark theme */
        .dark-theme .text-muted {
          color: #b0b0b0 !important; /* Lighter muted text */
        }
        .dark-theme .form-check-label {
          color: #e0e0e0; /* Light text for radio labels */
        }
        .dark-theme .form-check-input:checked {
            background-color: #A259E0; /* Accent color for checked radio */
            border-color: #A259E0;
        }

        /* Ensure the "Enter Your Details" text changes color */
        .dark-theme .form-title-text {
            color: #d0d0d0 !important; /* Lighter color for the form title */
        }
        .light-theme .form-title-text {
            color: #6f42c1;
        }


        /* Mobile Styles (≤576px) */
        @media (max-width: 576px) {
          .hero-section {
            padding-top: 60px;
            padding-right: 5px;
            padding-left: 5px;
            align-items: center !important;
            justify-content: center !important;
          }

          .form-card {
            max-width: 95vw !important;
            margin: 20px auto !important;
            padding: 2rem !important;
          }

          .gradient-text {
            font-size: 1.5rem !important;
          }

          .description-text {
            font-size: 1rem !important;
          }

          .submit-btn {
            font-size: 1.4rem !important;
            padding: 10px 0 !important;
          }

          .mode-label {
            font-size: 1.2rem !important;
          }

          .terms-text {
            font-size: 0.9rem !important;
          }
        }

        /* Small Mobile Styles (≤480px) */
        @media (max-width: 480px) {
          .form-card {
            padding: 1.5rem !important;
            border-radius: 20px !important;
          }

          .gradient-text {
            font-size: 1.3rem !important;
          }

          .description-text {
            font-size: 0.9rem !important;
          }

          .icon-container {
            width: 48px !important;
            height: 48px !important;
          }

          .submit-btn {
            font-size: 1.2rem !important;
          }
        }

        /* Tablet Portrait Styles (577px - 768px) */
        @media (min-width: 577px) and (max-width: 768px) {
          .hero-section {
            padding-top: 80px;
            justify-content: center !important;
          }

          .form-card {
            max-width: 90vw !important;
            margin: 30px auto !important;
            padding: 2.5rem !important;
          }

          .gradient-text {
            font-size: 1.8rem !important;
          }

          .submit-btn {
            font-size: 1.5rem !important;
          }
        }

        /* Tablet Landscape Styles (769px - 992px) */
        @media (min-width: 769px) and (max-width: 992px) {
          .hero-section {
            padding-top: 100px;
            justify-content: flex-end !important;
            padding-right: 30px !important;
          }

          .form-card {
            max-width: 450px !important;
            margin-right: 40px !important;
          }
        }

        /* Small Desktop Styles (993px - 1200px) */
        @media (min-width: 993px) and (max-width: 1200px) {
          .hero-section {
            justify-content: flex-end !important;
            padding-right: 40px !important;
          }

          .form-card {
            margin-right: 50px !important;
          }
        }

        /* Large Desktop Styles (≥1201px) */
        @media (min-width: 1201px) {
          .hero-section {
            justify-content: flex-end !important;
            padding-right: 10px !important;
          }

          .form-card {
            margin-right: 60px !important;
          }
        }

        /* Ultra-wide Screens (≥1400px) */
        @media (min-width: 1400px) {
          .form-card {
            margin-right: 80px !important;
            margin-top: 100px;
          }
        }
      `}</style>

      <div className="d-flex align-items-start justify-content-end w-100 hero-section" style={{
        backgroundImage: `url(${isLightTheme
            ? "/MainHome/Homebanner1.png"
            : "/MainHome/Homebanner5.png"
          })`
      }}>
        <div className={`card shadow-lg p-5 form-card ${isLightTheme ? 'light-theme' : 'dark-theme'}`} style={{ maxWidth: "500px", width: "100%" }}>
          {/* Header Section */}
          <div className="text-center mb-2">
            <div className="mx-auto mb-2 d-flex align-items-center justify-content-center icon-container">
              <i className="bi bi-calendar-check text-white fs-2"></i>
            </div>

            <h3 className="fw-bold mb-1 gradient-text">
              Start Your Free Session Today
            </h3>

            <div className="description-text" style={{ fontSize: "1.25rem" }}>
              Guidance from top trainers & professionals
            </div>
          </div>

          {/* Form Title */}
          <div className="mb-3 text-center fw-bold fs-5 form-title-text">
            Enter Your Details
          </div>

          {/* Form */}
          <form onSubmit={HandleSubmit}>
            {/* Name Field */}
            <div className="col-12 mb-3">
              <div className="rbt-form-group">
                <input
                  id="name"
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter your full name"
                  className={`form-control ${isLightTheme ? 'light-theme' : 'dark-theme'}`}
                  required
                />
              </div>
            </div>

            {/* Phone Field */}
            <div className="col-12 mb-3">
              <div className="rbt-form-group">
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter your mobile number"
                  className={`form-control ${isLightTheme ? 'light-theme' : 'dark-theme'}`}
                  required
                />
              </div>
            </div>

            {/* Email Field */}
            <div className="col-12 mb-3">
              <div className="rbt-form-group">
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email address"
                  className={`form-control ${isLightTheme ? 'light-theme' : 'dark-theme'}`}
                  required
                />
              </div>
            </div>

            {/* State Field */}
            <div className="col-12 mb-3">
              <div className="rbt-form-group">
                <input
                  id="state"
                  type="text"
                  name="state"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  placeholder="Enter your state"
                  className={`form-control ${isLightTheme ? 'light-theme' : 'dark-theme'}`}
                  required
                />
              </div>
            </div>

            {/* Mode Selection */}
            <div className="col-12 mb-3">
              <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 mt-2">
                <span
                  className="fw-semibold mode-label"
                  style={{ fontSize: "1.5rem", marginTop: "2px" }}
                >
                  Select Mode
                </span>

                <div className="d-flex gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="modeOnline"
                      name="mode"
                      value="Online"
                      checked={mode === "Online"}
                      onChange={() => setMode("Online")}
                    />
                    <label
                      className="form-check-label fw-semibold"
                      htmlFor="modeOnline"
                    >
                      Online
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="modeOffline"
                      name="mode"
                      value="Offline"
                      checked={mode === "Offline"}
                      onChange={() => setMode("Offline")}
                    />
                    <label
                      className="form-check-label fw-semibold"
                      htmlFor="modeOffline"
                    >
                      Offline
                    </label>
                  </div>
                </div>
              </div>
            </div>


            {/* Submit Button */}
            <button
              type="submit"
              className="btn w-100 py-3 fw-bold submit-btn"
            >
              Schedule
            </button>
          </form>

          {/* Terms */}
          <div className="text-center mt-3">
            <p className="small mb-0 terms-text">
              By continuing, you agree to our Terms & Conditions
            </p>
          </div>
        </div>
      </div>
    </>
  );
}






